import React from "react";
import AllImg from '../img/alltruck_medium.png'
function Allvehicle() {
  return (
    <img style={{width:"18px",height:"30px"}} src={AllImg} alt='all'></img>
  );
}

export default Allvehicle;
